<template>
<div>
  <b-container fluid>
    <b-row>
      <b-col lg="3" md="6" sm="12" v-for="declaration in declarations" :key="declaration.id">
        <div class="declaration-card card" @click="downloadPdf(declaration.id)">
          <div style="margin-right: 30px">
            <strong>{{ declaration.building.formatted_address }}</strong><br />
            {{ declaration.status | statusToPolish }}, typ {{ declaration.type | toPolish }}<br />
            <small>{{ declaration.created_at }}</small>
          </div>
          <b-icon-download font-scale="1.8" class="dicon" />
        </div>
      <b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import DeclarationsModel from "@/models/declarations";

export default {
  name: "ReceiptList",
  props: ["declarations"],
  components: {DeclarationsModel},
  methods: {
    downloadPdf(id) {
      window.open('/api/declarations/pdf/' + id, '_blank');
    }
  },
  filters: {
    toPolish(value) {
      if (!value) return '';
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    statusToPolish(status) {
      return {
        "DRAFT": 'Wersja robocza',
        "SUBMITTED": 'Złożona',
        "EDITED": 'Złożona w edycji',
      }[status];
    }
  }
}
</script>

<style scoped>
.declaration-card {
  padding: 10px;
  cursor: pointer;
  margin-bottom: 10px;
  position: relative;
}

.declaration-card:hover {
  background: #FFE;
}

.dicon {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
</style>
